const options = {
  5: "bg-yellow-500/5",
  10: "bg-yellow-500/10",
  25: "bg-yellow-500/25",
  50: "bg-yellow-500/50",
  75: "bg-yellow-500/75",
  90: "bg-yellow-500/90",
  100: "bg-yellow-500",
};

const from = {
  5: "from-yellow-500/5",
  10: "from-yellow-500/10",
  25: "from-yellow-500/25",
  50: "from-yellow-500/50",
  75: "from-yellow-500/75",
  90: "from-yellow-500/90",
  100: "from-yellow-500",
};

export default function getBackgroundYellow500(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
